const errorColor = '#A00E18';
const radioBCError = '#F6CCC766';

export const styles = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
  },
  label: {
    color: '#5E6073',
    fontWeight: 400,
    margin: 0,
    fontSize: '0.875rem',
    letterSpacing: 0,
    lineHeight: '20px',
  },
  input: {
    width: '100%',
    '& input': {
      width: '100%',
    },
    '& div': {
      width: '100%',
      '& div': {
        width: 'auto',
      },
    },
  },
  // shall remove later
  inputError: {
    width: '100%',
    backgroundColor: '#FBF1EF',
    borderBottom: `${errorColor} 2px solid`,
    '& input': {
      width: '100%',
      paddingLeft: '0',
    },
    '& input:focus-visible': {
      outline: 'none',
    },
    '& div': {
      width: '100%',
      borderColor: errorColor,
      '&:focus, &:hover, &:before, &:after': {
        borderColor: `transparent ${errorColor} !important`,
        boxShadow: `${errorColor} 0px 1px 0px 0px !important`,
      },
      '& div': {
        width: 'auto',
        backgroundColor: '#FBF1EF',
      },
    },
  },
  // shall remove later
  inputDisabled: {
    width: '100%',
    borderBottom: 'none',
    '& input': {
      width: '100%',
      paddingLeft: '0',
      cursor: 'default !important',
      color: 'inherit !important',
    },
    '& div': {
      width: '100%',
      color: 'inherit !important',
      borderColor: 'transparent',
      '& div': {
        width: 'auto',
      },
    },
  },
  error: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontWeight: '600',
    fontSize: '13px',
    lineHeight: '16px',
    marginTop: '8px',
    color: `${errorColor}`,

    '& path': {
      color: `${errorColor}`,
    },
    '& svg': {
      minWidth: '16px',
      minHeight: '16px',
    },
  },
};

// for reference
export const basicInputCustomStyles = {
  rootStyle: {},
  iconStyle: {},
  inputWrapperStyle: {},
  inputStyle: {},
  labelStyle: {},
  adornmentStyle: {},
};

export const generateCustomStyles = (isError, isDisabled) => ({
  rootStyle: {
    width: '100%',
    border: 'none',
  },
  labelStyle: { ...styles.label },
  inputWrapperStyle: {
    background: isError ? '#FBF1EF !important' : '',
    borderBottom: generateBorderColor(isError, isDisabled),
    ...disabledStyles(isDisabled),
  },
  inputStyle: {
    width: '100%',
    color: '#282B3E !important',
  },
});

const disabledStyles = (isDisabled) => {
  const stls = {
    marginTop: '8px',
    marginBottom: '8px',
  };
  return isDisabled ? stls : {};
};

export const generateBorderColor = (isError, isDisabled) => {
  if (isError) return `2px solid ${errorColor}`;
  if (isDisabled) return 'none';
  else return '1px solid #8E90A2';
};

export const generateRadioGroupStyles = (isError) => ({
  rootStyle: {},
  legendStyle: {},
  radioStyle: {
    marginLeft: 0,
    marginTop: 0,
    marginBottom: 0,
    borderColor: isError ? errorColor : '#8E90A2',
    background: isError ? radioBCError : '#FFFFFF',
  },
  labelStyle: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
  },
  noteStyle: {},
});
